import styled from 'styled-components';

export const IconHolder = styled.div`
    display: flex;
`;
